import dayjs from '../../dayjs';
import { getUserOffsetName } from '../index'

/**
 * @description: 判断传进来的时间是否是整点
 * @param {any} date
 * @return {*}
 */
export function isZeroClock(date: any) {
  return dayjs(date).format() === dayjs(new Date(date).toDateString()).format()
}

/**
 * @description: 判断传入的string类型的日期是否含有时分秒
 * @param {any} date
 * @return {*}
 */
export function isStrDateContainHMS(date: any, type?: string) {
  // const offset_name = getUserOffsetName()
  // const d = dayjs(date).tz(offset_name).hour(0).minute(0).second(0)
  // const date1 = dayjs(date).tz(offset_name).format()
  // const date2 = d.format()
  // if (typeof date === 'string' && date.length <= 10 && date1 === date2) return false
  // return true

  if (typeof date !== 'string') return false
  if (date.length <= 10) return false
  const regex = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1])) (?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/g
  if (regex.test(date)) return true
  const regex2 = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1])) (?:(?:[0-2][0-3])|(?:[0-1][0-9]))(?::(?:[0-5][0-9]))?(?::(?:[0-5][0-9]))?$/g
  if ((type === 'in' || type === 'out') && regex2.test(date)) return true
  const offset_name = getUserOffsetName()
  const d = dayjs(date).tz(offset_name).hour(0).minute(0).second(0)
  const date1 = dayjs(date).tz(offset_name).format()
  const date2 = d.format()
  return date1 !== date2
}